import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "lg:grid lg:grid-cols-12 lg:gap-x-5" }
const _hoisted_2 = { class: "space-y-6 sm:px-6 lg:col-span-7 lg:px-0" }
const _hoisted_3 = { class: "shadow-sm sm:overflow-hidden sm:rounded-md" }
const _hoisted_4 = { class: "space-y-6 bg-white px-4 py-6 sm:p-6" }
const _hoisted_5 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_6 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_7 = {
  key: 0,
  class: "grid grid-cols-3 gap-6"
}
const _hoisted_8 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_9 = {
  for: "name",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_10 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_11 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "name-error"
}
const _hoisted_12 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_13 = {
  for: "username",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_14 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_15 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "name-error"
}
const _hoisted_16 = { class: "mt-1 text-sm/6 text-gray-400" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "font-medium text-gray-600" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "mt-1 text-sm/6 text-gray-400" }
const _hoisted_21 = { class: "bg-gray-50 px-4 py-3 text-right sm:px-6" }
const _hoisted_22 = {
  type: "submit",
  class: "inline-flex justify-center rounded-md bg-blue-700 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-blue-600 focus:outline-hidden cursor-pointer"
}
const _hoisted_23 = { class: "shadow-sm sm:overflow-hidden sm:rounded-md" }
const _hoisted_24 = { class: "space-y-6 bg-white px-4 py-6 sm:p-6" }
const _hoisted_25 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_26 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_27 = { class: "grid grid-cols-6 gap-6" }
const _hoisted_28 = { class: "col-span-6 sm:col-span-6" }
const _hoisted_29 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_30 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "instagram_url-error"
}
const _hoisted_31 = { class: "col-span-6 sm:col-span-6" }
const _hoisted_32 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_33 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "facebook_url-error"
}
const _hoisted_34 = { class: "col-span-6 sm:col-span-6" }
const _hoisted_35 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_36 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "telegram_url-error"
}
const _hoisted_37 = { class: "col-span-6 sm:col-span-6" }
const _hoisted_38 = {
  for: "website_url",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_39 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_40 = ["placeholder"]
const _hoisted_41 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "website_url-error"
}
const _hoisted_42 = { class: "bg-gray-50 px-4 py-3 text-right sm:px-6" }
const _hoisted_43 = {
  type: "submit",
  class: "inline-flex justify-center rounded-md bg-blue-700 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-blue-600 focus:outline-hidden cursor-pointer"
}
const _hoisted_44 = { class: "shadow-sm sm:overflow-hidden sm:rounded-md" }
const _hoisted_45 = { class: "space-y-6 bg-white px-4 py-6 sm:p-6" }
const _hoisted_46 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_47 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_48 = { class: "col-span-6 sm:col-span-6" }
const _hoisted_49 = {
  for: "email",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_50 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_51 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "email-error"
}
const _hoisted_52 = { class: "col-span-6 sm:col-span-6 pt-3" }
const _hoisted_53 = {
  for: "current_password",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_54 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_55 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "current_password-error"
}
const _hoisted_56 = { class: "col-span-6 sm:col-span-6" }
const _hoisted_57 = {
  for: "password",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_58 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_59 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "password-error"
}
const _hoisted_60 = { class: "col-span-6 sm:col-span-6" }
const _hoisted_61 = {
  for: "password_confirmation",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_62 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_63 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "password_confirmation-error"
}
const _hoisted_64 = { class: "bg-gray-50 px-4 py-3 text-right sm:px-6" }
const _hoisted_65 = {
  type: "submit",
  class: "inline-flex justify-center rounded-md bg-blue-700 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-blue-600 focus:outline-hidden cursor-pointer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ControlsMenuComponent = _resolveComponent("ControlsMenuComponent")!
  const _component_AvatarComponent = _resolveComponent("AvatarComponent")!
  const _component_ExclamationCircleIcon = _resolveComponent("ExclamationCircleIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ControlsMenuComponent),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"])),
        enctype: "multipart/form-data"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t('settings.general')), 1),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('settings.general_tip')), 1)
            ]),
            (_ctx.user)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_AvatarComponent, {
                    class: "col-span-6 sm:col-span-3",
                    current_url: _ctx.user.avatar_url
                  }, null, 8, ["current_url"]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('settings.name')), 1),
                    _createElementVNode("div", _hoisted_10, [
                      _withDirectives(_createElementVNode("input", {
                        id: "name",
                        name: "name",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                        type: "text",
                        autocomplete: "name",
                        class: _normalizeClass({
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': _ctx.hasError('name')
                                        })
                      }, null, 2), [
                        [_vModelText, _ctx.form.name]
                      ]),
                      (_ctx.hasError('name'))
                        ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                            key: 0,
                            class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                            "aria-hidden": "true"
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.hasError('name'))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.getError('name')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('settings.address')), 1),
                    _createElementVNode("div", _hoisted_14, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "username",
                        id: "username",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.username) = $event)),
                        class: _normalizeClass({
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': _ctx.hasError('username')
                                        }),
                        placeholder: "janesmith"
                      }, null, 2), [
                        [_vModelText, _ctx.form.username]
                      ]),
                      (_ctx.hasError('username'))
                        ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                            key: 0,
                            class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                            "aria-hidden": "true"
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.hasError('username'))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.getError('username')), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_16, [
                      (_ctx.form.username)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                            _createTextVNode(_toDisplayString(_ctx.$t('settings.your_address')) + " ", 1),
                            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.form.username) + ".gallera.io", 1)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_19))
                    ]),
                    _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t('settings.address_tip')), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("button", _hoisted_22, _toDisplayString(_ctx.$t('settings.save')), 1)
          ])
        ])
      ], 32),
      _createElementVNode("form", {
        onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_25, _toDisplayString(_ctx.$t('settings.contacts')), 1),
              _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.$t('settings.contacts_tip')), 1)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _cache[13] || (_cache[13] = _createElementVNode("label", {
                  for: "instagram_url",
                  class: "block text-sm/6 font-medium text-gray-900"
                }, "Instagram", -1)),
                _createElementVNode("div", _hoisted_29, [
                  _withDirectives(_createElementVNode("input", {
                    id: "instagram_url",
                    name: "instagram_url",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.instagram_url) = $event)),
                    type: "text",
                    autocomplete: "instagram_url",
                    class: _normalizeClass({
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': _ctx.hasError('instagram_url')
                                        })
                  }, null, 2), [
                    [_vModelText, _ctx.form.instagram_url]
                  ]),
                  (_ctx.hasError('instagram_url'))
                    ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                        key: 0,
                        class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                        "aria-hidden": "true"
                      }))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.hasError('instagram_url'))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_ctx.getError('instagram_url')), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _cache[14] || (_cache[14] = _createElementVNode("label", {
                  for: "facebook_url",
                  class: "block text-sm/6 font-medium text-gray-900"
                }, "Facebook", -1)),
                _createElementVNode("div", _hoisted_32, [
                  _withDirectives(_createElementVNode("input", {
                    id: "facebook_url",
                    name: "facebook_url",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.facebook_url) = $event)),
                    type: "text",
                    autocomplete: "facebook_url",
                    class: _normalizeClass({
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': _ctx.hasError('facebook_url')
                                        })
                  }, null, 2), [
                    [_vModelText, _ctx.form.facebook_url]
                  ]),
                  (_ctx.hasError('facebook_url'))
                    ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                        key: 0,
                        class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                        "aria-hidden": "true"
                      }))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.hasError('facebook_url'))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(_ctx.getError('facebook_url')), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_34, [
                _cache[15] || (_cache[15] = _createElementVNode("label", {
                  for: "telegram_url",
                  class: "block text-sm/6 font-medium text-gray-900"
                }, "Telegram", -1)),
                _createElementVNode("div", _hoisted_35, [
                  _withDirectives(_createElementVNode("input", {
                    id: "telegram_url",
                    name: "telegram_url",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.telegram_url) = $event)),
                    type: "text",
                    autocomplete: "telegram_url",
                    class: _normalizeClass({
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': _ctx.hasError('telegram_url')
                                        })
                  }, null, 2), [
                    [_vModelText, _ctx.form.telegram_url]
                  ]),
                  (_ctx.hasError('telegram_url'))
                    ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                        key: 0,
                        class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                        "aria-hidden": "true"
                      }))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.hasError('telegram_url'))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString(_ctx.getError('telegram_url')), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t('settings.website')), 1),
                _createElementVNode("div", _hoisted_39, [
                  _withDirectives(_createElementVNode("input", {
                    id: "website_url",
                    name: "website_url",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.website_url) = $event)),
                    type: "text",
                    autocomplete: "website_url",
                    placeholder: _ctx.user ? `https://${_ctx.user.username}.gallera.io` : 'https://username.gallera.io',
                    class: _normalizeClass({
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': _ctx.hasError('website_url')
                                        })
                  }, null, 10, _hoisted_40), [
                    [_vModelText, _ctx.form.website_url]
                  ]),
                  (_ctx.hasError('website_url'))
                    ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                        key: 0,
                        class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                        "aria-hidden": "true"
                      }))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.hasError('website_url'))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_41, _toDisplayString(_ctx.getError('website_url')), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("button", _hoisted_43, _toDisplayString(_ctx.$t('settings.save')), 1)
          ])
        ])
      ], 32),
      _createElementVNode("form", {
        onSubmit: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitSecurity && _ctx.submitSecurity(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_46, _toDisplayString(_ctx.$t('settings.security')), 1),
              _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.$t('settings.security_tip')), 1)
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.$t('settings.email')), 1),
              _createElementVNode("div", _hoisted_50, [
                _withDirectives(_createElementVNode("input", {
                  id: "email",
                  name: "email",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.email) = $event)),
                  type: "email",
                  disabled: "",
                  autocomplete: "email",
                  class: _normalizeClass({
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 disabled:outline-gray-200': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': _ctx.hasError('email')
                                        })
                }, null, 2), [
                  [_vModelText, _ctx.form.email]
                ]),
                (_ctx.hasError('email'))
                  ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                      key: 0,
                      class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                      "aria-hidden": "true"
                    }))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.hasError('email'))
                ? (_openBlock(), _createElementBlock("p", _hoisted_51, _toDisplayString(_ctx.getError('email')), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.$t('settings.current_password')), 1),
              _createElementVNode("div", _hoisted_54, [
                _withDirectives(_createElementVNode("input", {
                  id: "current_password",
                  name: "current_password",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.securityForm.current_password) = $event)),
                  type: "password",
                  class: _normalizeClass({
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': _ctx.hasError('current_password')
                                        })
                }, null, 2), [
                  [_vModelText, _ctx.securityForm.current_password]
                ]),
                (_ctx.hasError('current_password'))
                  ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                      key: 0,
                      class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                      "aria-hidden": "true"
                    }))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.hasError('current_password'))
                ? (_openBlock(), _createElementBlock("p", _hoisted_55, _toDisplayString(_ctx.getError('current_password')), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.$t('settings.current_password')), 1),
              _createElementVNode("div", _hoisted_58, [
                _withDirectives(_createElementVNode("input", {
                  id: "password",
                  name: "password",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.securityForm.password) = $event)),
                  type: "password",
                  class: _normalizeClass({
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': _ctx.hasError('password')
                                        })
                }, null, 2), [
                  [_vModelText, _ctx.securityForm.password]
                ]),
                (_ctx.hasError('password'))
                  ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                      key: 0,
                      class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                      "aria-hidden": "true"
                    }))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.hasError('password'))
                ? (_openBlock(), _createElementBlock("p", _hoisted_59, _toDisplayString(_ctx.getError('password')), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.$t('settings.new_password_confirmation')), 1),
              _createElementVNode("div", _hoisted_62, [
                _withDirectives(_createElementVNode("input", {
                  id: "password_confirmation",
                  name: "password_confirmation",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.securityForm.password_confirmation) = $event)),
                  type: "password",
                  class: _normalizeClass({
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': _ctx.hasError('password_confirmation')
                                        })
                }, null, 2), [
                  [_vModelText, _ctx.securityForm.password_confirmation]
                ]),
                (_ctx.hasError('password_confirmation'))
                  ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                      key: 0,
                      class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                      "aria-hidden": "true"
                    }))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.hasError('password_confirmation'))
                ? (_openBlock(), _createElementBlock("p", _hoisted_63, _toDisplayString(_ctx.getError('password_confirmation')), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("button", _hoisted_65, _toDisplayString(_ctx.$t('settings.save')), 1)
          ])
        ])
      ], 32)
    ])
  ]))
}